"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nanoid = _interopRequireDefault(require("nanoid"));

var Cookies = _interopRequireWildcard(require("js-cookie"));

var _sdkLocalStorage = _interopRequireDefault(require("@energych/sdk-local-storage"));

var _cookieStorage = _interopRequireDefault(require("@energych/sdk-local-storage/lib/cookie-storage"));

var _client = require("./client");

var _token = _interopRequireDefault(require("./token"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BrowserClient =
/*#__PURE__*/
function (_Client) {
  _inherits(BrowserClient, _Client);

  function BrowserClient() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BrowserClient);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BrowserClient)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cookieName", 'access_token');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tokenRenewInterval", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renewTimeout", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "storage", new _sdkLocalStorage.default({
      fallbackStorage: new _cookieStorage.default(),
      namespace: 'auth'
    }));

    return _this;
  }

  _createClass(BrowserClient, [{
    key: "init",

    /**
     * Initialize the authentication state by using the stored access token
     */
    value: function init() {
      var _this2 = this;

      var triggerEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (Cookies.get(this.cookieName)) {
        var accessToken = new _token.default(Cookies.get(this.cookieName) || '');

        if (this.setAccessToken(accessToken)) {
          if (triggerEvent) {
            this.connector.emit('login', {
              successful: true,
              userInitialized: false
            });
          }

          this.canRenew = true;
        } else {
          Cookies.remove(this.cookieName);
        }
      } // start token renewal interval


      if (this.connector.getConfig().tokenRenewMode === 'auto' && !this.tokenRenewInterval) {
        this.tokenRenewInterval = window.setInterval(function () {
          _this2.checkForTokenRenewal('auto', 3000 * 1000);
        }, 600 * 1000);
        this.checkForTokenRenewal('auto', 3000 * 1000);
      }
    }
    /**
     * Called when a method is called but the access token is invalid or expired
     */

  }, {
    key: "onInvalidToken",
    value: function onInvalidToken() {
      if (this.accessToken) {
        this.accessToken = null;
        this.canRenew = false;
        Cookies.remove(this.cookieName);
        this.connector.emit('logout');
      }
    }
    /**
     * Redirect the user to the dedicated login page
     */

  }, {
    key: "login",
    value: function login(redirectToPath, loginCase) {
      if (this.accessToken && (!loginCase || loginCase === 'default')) {
        this.connector.log('info', 'user is already logged in');
        return;
      }

      var config = this.connector.getConfig();
      this.redirectTo("https://".concat(config.domain, "/authorize"), this.buildLoginParams(redirectToPath, false, loginCase));
    }
    /**
     * Logout the user
     */

  }, {
    key: "logout",
    value: function logout() {
      var storeResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var cookieOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.accessToken) {
        this.connector.log('info', 'user is already logged out');
        return;
      } // remove cookie


      Cookies.remove(this.cookieName);

      if (storeResult) {
        this.storage.set('login-result', JSON.stringify({
          successful: true,
          action: 'logout'
        }));
      }

      var config = this.connector.getConfig();

      if (cookieOnly) {
        window.location.href = "".concat(window.location.protocol, "//").concat(window.location.host).concat(config.logoutRedirect);
        return;
      } // redirect to ringier connect to also let them logout the user


      var params = {
        client_id: config.clientId,
        returnTo: "".concat(window.location.protocol, "//").concat(window.location.host).concat(config.logoutRedirect)
      };
      this.redirectTo("https://".concat(config.domain, "/v2/logout"), params);
    }
    /**
     * Open the profile in a new tab
     */

  }, {
    key: "openProfile",
    value: function openProfile() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/energy';
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (newTab) {
        window.open(this.connector.getConfig().profile + page, '_blank');
      } else {
        window.location.href = this.connector.getConfig().profile + page;
      }
    }
    /**
     * Parse the hash and try to login the user
     */

  }, {
    key: "parseHash",
    value: function parseHash() {
      var _this3 = this;

      var storeResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // tslint:disable-next-line

      return new Promise(function (resolve, reject) {
        var queryParams = _this3.parseQueryString(window.location.search.substr(1));

        var hashParams = _this3.parseQueryString(window.location.hash.substr(1));

        console.log(JSON.stringify(hashParams.toString()));
        var redirectTo = queryParams.redirectTo || '/'; // make sure only paths are allowed and not full urls to prevent possible phising attacks

        if (redirectTo.substr(0, 1) !== '/' || redirectTo.substr(1, 1) === '/') {
          redirectTo = '/';
        } // provide a method to fail t he parseHash call


        var fail = function fail(message) {
          _this3.accessToken = null;

          _this3.storage.clear();

          _this3.connector.log('error', message); // handle renewToken request differently


          if (queryParams.isIframe) {
            return _this3.handleRenewToken(false);
          }

          _this3.connector.emit('login', {
            message: message,
            successful: false
          });

          if (storeResult) {
            _this3.storage.set('login-result', JSON.stringify({
              successful: false,
              action: 'login',
              message: message
            }));
          }

          var error = new Error(message);
          error.redirectTo = redirectTo;
          reject(error);
        }; // check for auth0 errors


        if (_typeof(hashParams.error) !== undefined && hashParams.error) {
          if (_typeof(hashParams.error_description) !== undefined && hashParams.error_description) {
            return fail(hashParams.error_description.replace(/\+/g, ' '));
          }

          return fail("Ein unbekannter Fehler ist aufgetreten. Code: ".concat(hashParams.error));
        } // check for all required params


        var requiredParams = ['access_token', 'id_token', 'expires_in', 'state'];

        for (var _i = 0; _i < requiredParams.length; _i++) {
          var requiredParam = requiredParams[_i];

          if (typeof hashParams[requiredParam] === 'undefined') {
            return fail("Required parameter ".concat(requiredParam, " not found"));
          }
        } // check for storage


        if (!_this3.storage.get('state') || !_this3.storage.get('nonce')) {
          return fail('Storage is empty');
        } // validate state


        if (hashParams.state !== _this3.storage.get('state')) {
          return fail('State does not match');
        } // validate idToken


        var idToken = new _token.default(hashParams.id_token);

        if (!idToken.isValid() || idToken.getParsedToken().nonce !== _this3.storage.get('nonce')) {
          return fail('Invalid ID Token');
        } // validate accessToken


        var accessToken = new _token.default(hashParams.access_token);

        if (!accessToken.isValid() || !_this3.setAccessToken(accessToken)) {
          return fail('Invalid Access Token');
        } // tokens are successfully validated on the client so we can clear the storage


        _this3.storage.remove('state');

        _this3.storage.remove('nonce'); // validate the token on the server to check for a valid signature


        _this3.getUser(true).then(function (user) {
          if (user) {
            // save cookie
            var expiresAt = new Date(accessToken.getParsedToken().exp * 1000);
            Cookies.set(_this3.cookieName, accessToken.getToken(), {
              expires: expiresAt
            }); // handle renewToken request differently

            if (queryParams.isIFrame) {
              _this3.handleRenewToken(true);
            }

            if (storeResult) {
              _this3.storage.set('login-result', JSON.stringify({
                successful: true,
                action: 'login'
              }));
            } // login was successful


            _this3.connector.emit('login', {
              successful: true,
              userInitialized: true
            });

            _this3.canRenew = true;
            resolve(idToken.getParsedToken().nonce);
          } else {
            _this3.connector.log('error', user);

            fail('Invalid Access Token (server side validation failed)');
          }
        }).catch(function (e) {
          _this3.connector.log('error', e);

          fail('Invalid Access Token (server side validation failed)');
        });
      });
    }
    /**
     * Return previously stored login result
     */

  }, {
    key: "getStoredLoginResult",
    value: function getStoredLoginResult() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var result = this.storage.get('login-result', null);

      if (clear) {
        this.storage.remove('login-result');
      }

      return result ? JSON.parse(result) : result;
    }
    /**
     * Renew the current token
     */

  }, {
    key: "renewToken",
    value: function renewToken() {
      var _this4 = this;

      this.canRenew = false;
      this.connector.log('info', 'renewing token');
      var url = "https://".concat(this.connector.getConfig().domain, "/authorize");

      var params = _objectSpread({}, this.buildLoginParams(null, true), {
        prompt: 'none'
      });

      if (document.getElementById('renew-token-iframe')) {
        return;
      }

      var iframe = this.createIframe("".concat(url, "?").concat(this.obejctToQueryString(params))); // handle the message event which the iframe triggers on a successful/failed login

      var onMessageEvent = function onMessageEvent(event) {
        var messagePrefix = '@energych/sdk-auth/renew-token:';

        if (event.data.substr && event.data.substr(0, messagePrefix.length) === messagePrefix) {
          window.clearTimeout(_this4.renewTimeout); // cleanup event and iframe

          window.removeEventListener('message', onMessageEvent);
          iframe.remove();
          var response = event.data.substr(messagePrefix.length);

          _this4.connector.log('info', 'renewToken response:', response); // handle response


          if (response === 'true') {
            _this4.init(false);

            _this4.connector.log('info', 'new token expires at', _this4.accessToken.getExpiresAt());
          } else {
            _this4.onInvalidToken();
          }
        }
      };

      window.addEventListener('message', onMessageEvent); // if no message was received within 20s (default), handle it as a failed login

      this.renewTimeout = window.setTimeout(function () {
        window.removeEventListener('message', onMessageEvent);

        if (_this4.accessToken.getExpiresAt() - new Date().getTime() < 900 * 1000) {
          _this4.onInvalidToken();
        }
      }, this.connector.getConfig().renewTokenTimeout);
    }
    /**
     * Handle renewToken requests within the iframe
     *
     * @param loginSuccessful
     */

  }, {
    key: "handleRenewToken",
    value: function handleRenewToken(loginSuccessful) {
      if (window.parent && window.parent.postMessage) {
        this.connector.log('info', 'posting renew message to parent:', loginSuccessful);
        window.parent.postMessage("@energych/sdk-auth/renew-token:".concat(loginSuccessful ? 'true' : 'false'), "".concat(window.location.protocol, "//").concat(window.location.host));
      }
    }
    /**
     * Build the params for the login request
     *
     * @param redirectToPath
     */

  }, {
    key: "buildLoginParams",
    value: function buildLoginParams(redirectToPath, isIFrame, loginCase) {
      var config = this.connector.getConfig();
      var redirectTo = redirectToPath; // get redirectTo param

      if (typeof redirectTo !== 'string') {
        if (window.location.pathname === this.connector.getConfig().loginRedirect) {
          redirectTo = this.parseQueryString(window.location.search.substr(1)).redirectTo;

          if (!redirectTo) {
            redirectTo = '/';
          }
        } else {
          redirectTo = window.location.pathname;
        }
      }

      console.log('redirectTo', redirectTo); // create random state and nonce and store them

      var state = (0, _nanoid.default)(32);
      var nonce = redirectTo;
      this.storage.set('state', state);
      this.storage.set('nonce', nonce);
      var isIFrameParam = isIFrame ? "?isIFrame=".concat(isIFrame) : ''; // build the get params

      return _objectSpread({
        state: state,
        nonce: nonce,
        client_id: config.clientId,
        response_type: config.responseType,
        redirect_uri: "".concat(window.location.protocol, "//").concat(window.location.host).concat(config.loginRedirect) + "".concat(isIFrameParam),
        scope: config.scope,
        audience: config.audience
      }, loginCase ? {
        login_case: loginCase
      } : {});
    }
    /**
     * Create a new iframe
     *
     * @param src
     */

  }, {
    key: "createIframe",
    value: function createIframe(src) {
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.id = 'renew-token-iframe';
      document.body.appendChild(iframe);
      iframe.src = src;
      return iframe;
    }
    /**
     * Parses a query string and returns the object
     *
     * @param queryString
     */

  }, {
    key: "parseQueryString",
    value: function parseQueryString(queryString) {
      var params = {};
      queryString.split('&').forEach(function (kv) {
        var _kv$split = kv.split('='),
            _kv$split2 = _slicedToArray(_kv$split, 2),
            key = _kv$split2[0],
            value = _kv$split2[1];

        params[key] = decodeURIComponent(value);
      });
      return params;
    }
    /**
     * Create a query string from an object
     *
     * @param params
     */

  }, {
    key: "obejctToQueryString",
    value: function obejctToQueryString(params) {
      return Object.entries(params).map(function (kv) {
        return kv.map(encodeURIComponent).join('=');
      }).join('&');
    }
    /**
     * Redirect to the given url with the provided GET parameters
     *
     * @param url
     * @param params
     */

  }, {
    key: "redirectTo",
    value: function redirectTo(url, params) {
      window.location.href = "".concat(url, "?").concat(this.obejctToQueryString(params));
    }
  }]);

  return BrowserClient;
}(_client.Client);

exports.default = BrowserClient;